var _defs, _path, _path2, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLoyalty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    stroke: props.color,
    clipPath: "url(#Icon-Loyalty_svg__clip0_7216_36406)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.99 9.25a1.5 1.5 0 010 1.5l-3.846 6.66a1.5 1.5 0 01-1.299.75h-7.69a1.5 1.5 0 01-1.3-.75L3.01 10.75a1.5 1.5 0 010-1.5l3.846-6.66a1.5 1.5 0 011.299-.75h7.69a1.5 1.5 0 011.3.75l3.845 6.66z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12 22.5v-12M11.804 16.678l-4.015-5.734M12.196 16.678l4.015-5.734"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Icon-Loyalty_svg__clip0_7216_36406"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIconLoyalty;